module.exports = __webpack_public_path__ + "static/_camosunLogo-6188e7f7b7f9bfeebd6317a43c77bd7a.png";